import PageTitleComponent from "../../components/PageTitle";
import SubscribersList from "../../components/Subscribers";

export default function SubscribersScreen(){
return <div>
    <PageTitleComponent title="Subscribers" />
    <SubscribersList/>
</div>
}